import { Component, InjectionToken, Type } from '@angular/core';
import { Scanner } from './data/scanner';
import { ScannerService } from './services/scanner.service';
import { LabelType } from './data/label-type';

export type ScannerServiceSelector = (scanners: Scanner[]) => ScannerService;

export const SOFTLINE_CONFIG_SCANNER_SELECTOR =
  new InjectionToken<ScannerServiceSelector>('SCAN_SERVICE_SELECTOR');
export const SOFTLINE_CONFIG_SCANNER = new InjectionToken<any>('SOFTLINE_CONFIG_SCANNER'); // new InjectionToken<Scanner[]>('SOFTLINE_CONFIG_SCANNER');

export const SOFTLINE_SETTINGS_SCANNER = 'scanner';

export const SOFTLINE_SCANNER_ALL_LABEL_TYPES: LabelType[] = [
  'codabar',
  'code39',
  'code93',
  'code128',
  'ean8',
  'ean13',
  'ean128',
  'itf',
  'rss14',
  'upc_a',
  'upc_e0',
  'upc_e1',
  'msi',
  'qrcode',
  'pdf417',
];
